<script>
    import { actionLog } from './actionLog.js';
</script>

<action-log>
    <header>Action Log</header>
    <ul>
        {#each $actionLog as entry (entry.id)}
            <li>
                <span class="entry-name">{entry.name}</span>
                <span class="entry-deltas">
                    {#each entry.deltas as d}
                        <sl-badge type="{d.good ? 'success' : 'danger'}" pill>
                            {d.delta > 0 ? '+' : '-'}{Math.abs(d.delta).toFixed(2)} {d.label}
                        </sl-badge>
                    {:else}
                        <small class="no-effect">no stat effect</small>
                    {/each}
                </span>
            </li>
        {:else}
            <li class="empty">Nothing done yet...</li>
        {/each}
    </ul>
</action-log>

<style>
    action-log {
        position: fixed;
        right: 1em;
        bottom: 5.5em;
        width: 20em;
        max-height: 40vh;
        display: flex;
        flex-direction: column;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 10px;
        overflow: hidden;
        z-index: 1;
    }
    header {
        padding: 0.4em 0.7em;
        font-weight: bold;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        flex-shrink: 0;
    }
    ul {
        list-style: none;
        margin: 0;
        padding: 0.3em 0.5em;
        overflow-y: auto;
    }
    li {
        padding: 0.3em 0.2em;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
    li:last-child {
        border-bottom: none;
    }
    li.empty {
        color: rgba(0, 0, 0, 0.5);
        font-style: italic;
    }
    .entry-name {
        display: block;
        font-size: 0.85em;
        font-weight: bold;
    }
    .entry-deltas {
        display: flex;
        flex-wrap: wrap;
        gap: 0.2em;
        margin-top: 0.2em;
    }
    .entry-deltas sl-badge {
        font-size: 0.7em;
    }
    .no-effect {
        color: rgba(0, 0, 0, 0.5);
        font-size: 0.75em;
    }
</style>
